import { useState, useCallback } from "react";
import { useScopeId } from "@core/hooks/useRouteParamId";
import { FinanceAllocationRuleKpi } from "@features/admin/finance/allocation-rule/types/financeAllocationRule";
import { fetchAllocationRuleTemplateKpisAsync } from "@features/admin/finance/allocation-rule/services/financeAllocationRuleSvc";

export function useFinanceAllocationRuleOptions() {
    const resolvedNationId = useScopeId() ?? 0;

    const [templateKpis, setTemplateKpis] = useState<FinanceAllocationRuleKpi[]>([]);
    const [templateKpisLoading, setTemplateKpisLoading] = useState(false);
    const [templateKpisError, setTemplateKpisError] = useState<string | null>(null);

    const fetchTemplateKpis = useCallback(async () => {
        let cancelled = false;
        setTemplateKpisLoading(true);
        setTemplateKpisError(null);
        try {
            const response = await fetchAllocationRuleTemplateKpisAsync(resolvedNationId);
            if (!cancelled) {
                setTemplateKpis(response.getData() ?? []);
            }
        } catch (e: any) {
            if (!cancelled) {
                setTemplateKpisError(e?.message ?? "Failed to load KPIs.");
            }
        } finally {
            if (!cancelled) {
                setTemplateKpisLoading(false);
            }
        }
        return () => { cancelled = true; };
    }, [resolvedNationId]);

    return { templateKpis, templateKpisLoading, templateKpisError, fetchTemplateKpis };
}
